<nav class="mobile-nav">
  @for (link of links(); track link.route) {
    <a
      class="mobile-link"
      [routerLink]="'/' + link.route"
      [queryParams]="link.queryParams"
      routerLinkActive="active"
      (click)="navigated.emit()"
    >
      {{ link.label }}
    </a>
  }

  @if (showCreate()) {
    <a
      class="mobile-create-link"
      mat-flat-button
      color="primary"
      routerLink="/upload"
      (click)="navigated.emit()"
    >
      <mat-icon>add</mat-icon>
      {{ "shared.navigation_bar.create" | translate }}
    </a>
  }

  <button type="button" class="mobile-link mobile-link--logout" (click)="logout()">
    {{ "shared.navigation_bar.logout" | translate }}
  </button>
</nav>
